import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { creditAPI } from "../services/api";
import { useTranslation } from "react-i18next";

const MockCheckout = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const sessionId = location.pathname.split("/").pop();
  const amount = params.get("amount");

  const handlePayment = async (success) => {
    setLoading(true);
    try {
      const response = await creditAPI.simulatePayment(sessionId, success);
      navigate(response.data.redirectUrl);
    } catch (error) {
      console.error(t("errors.paymentSimulationFailed"), error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 400, mx: "auto", mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {t("mockCheckout.title")}
        </Typography>
        <Typography gutterBottom>
          {t("mockCheckout.amount")}: ${amount}
        </Typography>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handlePayment(true)}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              t("mockCheckout.successButton")
            )}
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => handlePayment(false)}
            disabled={loading}
          >
            {t("mockCheckout.failureButton")}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default MockCheckout;
